"use strict";
// (C) 2021-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidationData = exports.validateDrillDefinition = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var general_1 = require("../../../events/general");
var insightDrillDefinitionUtils_1 = require("./insightDrillDefinitionUtils");
var insightResolver_1 = require("../../../utils/insightResolver");
var displayFormResolver_1 = require("../../../../model/utils/displayFormResolver");
var drillTargetsSelectors_1 = require("../../../store/drillTargets/drillTargetsSelectors");
var accessibleDashboardsSelectors_1 = require("../../../store/accessibleDashboards/accessibleDashboardsSelectors");
var inaccessibleDashboardsSelectors_1 = require("../../../store/inaccessibleDashboards/inaccessibleDashboardsSelectors");
function validateDrillDefinition(drillDefinition, validationData, ctx, cmd) {
    var _a;
    var item = drillDefinition;
    // validate drill targets
    if (!((_a = validationData.drillTargets) === null || _a === void 0 ? void 0 : _a.availableDrillTargets)) {
        throw general_1.invalidArgumentsProvided(ctx, cmd, "Drill targets not set");
    }
    // validate drills origin
    try {
        item = insightDrillDefinitionUtils_1.validateDrillDefinitionOrigin(item, validationData.drillTargets.availableDrillTargets);
    }
    catch (ex) {
        var messageDetail = ex.message;
        throw general_1.invalidArgumentsProvided(ctx, cmd, "Invalid drill origin for InsightDrillDefinition. Error: " + messageDetail);
    }
    // validate drill
    var validationContext = {
        dashboardsMap: validationData.accessibleDashboardMap,
        insightsMap: validationData.resolvedInsights.resolved,
        displayFormsMap: validationData.resolvedDisplayForms.resolved,
        availableDrillTargets: validationData.drillTargets.availableDrillTargets,
        inaccessibleDashboardsMap: validationData.inaccessibleDashboardsMap,
    };
    try {
        item = insightDrillDefinitionUtils_1.validateInsightDrillDefinition(item, validationContext);
    }
    catch (ex) {
        var messageDetail = ex.message;
        throw general_1.invalidArgumentsProvided(ctx, cmd, "Invalid InsightDrillDefinition. Error: " + messageDetail);
    }
    return item;
}
exports.validateDrillDefinition = validateDrillDefinition;
function getValidationData(widgetRef, drillsToModify, ctx) {
    var selectDrillTargetsByWidgetRefSelector, drillTargets, accessibleDashboardMap, inaccessibleDashboardsMap, insightRefs, resolvedInsights, displayFormIds, resolvedDisplayForms;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                selectDrillTargetsByWidgetRefSelector = drillTargetsSelectors_1.selectDrillTargetsByWidgetRef(widgetRef);
                return [4 /*yield*/, effects_1.select(selectDrillTargetsByWidgetRefSelector)];
            case 1:
                drillTargets = _a.sent();
                return [4 /*yield*/, effects_1.select(accessibleDashboardsSelectors_1.selectAccessibleDashboardsMap)];
            case 2:
                accessibleDashboardMap = _a.sent();
                return [4 /*yield*/, effects_1.select(inaccessibleDashboardsSelectors_1.selectInaccessibleDashboardsMap)];
            case 3:
                inaccessibleDashboardsMap = _a.sent();
                insightRefs = insightDrillDefinitionUtils_1.extractInsightRefs(drillsToModify);
                return [4 /*yield*/, effects_1.call(insightResolver_1.resolveInsights, ctx, insightRefs)];
            case 4:
                resolvedInsights = _a.sent();
                displayFormIds = insightDrillDefinitionUtils_1.extractDisplayFormIdentifiers(drillsToModify);
                return [4 /*yield*/, effects_1.call(displayFormResolver_1.resolveDisplayFormMetadata, ctx, displayFormIds)];
            case 5:
                resolvedDisplayForms = _a.sent();
                return [2 /*return*/, {
                        drillTargets: drillTargets,
                        accessibleDashboardMap: accessibleDashboardMap,
                        resolvedInsights: resolvedInsights,
                        resolvedDisplayForms: resolvedDisplayForms,
                        inaccessibleDashboardsMap: inaccessibleDashboardsMap,
                    }];
        }
    });
}
exports.getValidationData = getValidationData;
//# sourceMappingURL=insightDrillDefinitionValidation.js.map